import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { AgGridFilterOption } from 'core/enums';
import { formatDate, formatQuantity } from 'core/utils';

export const columnDef = (): ColDef[] => [
  {
    colId: 'poNumber',
    headerName: t('headerPurchaseOrder'),
    field: 'poNumber',
    flex: 1,
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'promiseDate',
    headerName: t('headerPromiseDate'),
    field: 'promiseDate',
    flex: 1,
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
    },
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: 'poCreationDate',
    headerName: t('headerPoCreationDate'),
    field: 'poCreationDate',
    flex: 1,
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
    },
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: 'quantity',
    headerName: t('headerQty'),
    field: 'quantity',
    flex: 1,
    filter: 'agNumberColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN_OR_EQUAL,
    },
    valueGetter: ({ data }) => data && formatQuantity(data.quantity),
  },
];
